<template>
	<div>
		<div class="table_description table_description_filter">
			<div class="tertiary_color text_left"></div>
		</div>
		<div class="flex filter_table">
			<div class="flex flex_column w_100">
				<AgItem
					v-on:getGridApi="getGridApi"
					:rowData="rowData"
					:columnDefs="columnDefs"
					v-on:sortChanged="sortChanged"
				></AgItem>
				<Pagination
					:totalNum="totalNum"
					:pageSize="pageSize"
					:sizeChange="sizeChange"
					:currentChange="currentChange"
					:currentPage="page"
				></Pagination>
			</div>
		</div>
		<ContractsEditModal ref="relationModal" @success="getList"></ContractsEditModal>
		<TrackProgressModal ref="TrackProgressModal" @change="getList"></TrackProgressModal>
	</div>
</template>

<script>
import AgItem from "src/components/templates/agGrid/AgItem.vue";
import Pagination from "src/components/templates/common/Pagination.vue";
import PaginationParent from "src/components/templates/common/PaginationParent.vue";
import {asDecimal, asLocalizedDate, asMoneyAmount} from "src/components/templates/agGrid/formatter/valueFormatters";
import ContractsEditModal from "@/components/templates/trackPay/ContractsEditModal";
import {trackPayApi} from "../../../common/api/trackPayApi";
import TrackProgressModal from "@/components/templates/trackPay/TrackProgressModal";

export default {
	extends: PaginationParent,
	components: {
		AgItem,
		Pagination,
		ContractsEditModal,
		TrackProgressModal
	},
	data() {
		return {
			rowData: [{}],
			columnDefs: [],
			gridApi: null,
			filters: [],
			sorting: [],
		};
	},
	beforeMount() {
		this.setColumnDefs();
		this.getList();
	},
	methods: {
		sortChanged(sortData) {
			this.sorting = sortData;
			this.initPage();
			this.getList();
		},
		getGridApi(gApi) {
			this.gridApi = gApi;
		},
		setColumnDefs() {
			this.columnDefs = [
				{
					headerName: this.$t("trackPay.contractsTable.customer"),
					children: [
						{
							headerName: this.$t("common.label.name"),
							field: "debtorName",
							minWidth: 300,
							sortable: true,
							nameType: "debtorName",
							idType: "debtorId",
							cellRendererFramework: "CompanyTem"
						}
					]
				},
				{
					headerName: this.$t("trackPay.contractsTable.contract"),
					children: [
						{
							headerName: this.$t("trackPay.id"),
							field: "uuid",
							minWidth: 150,
							sortable: true,
						},
						{
							headerName: this.$t("common.orderNumber"),
							field: "invoiceNumber",
							sortable: true,
							minWidth: 200
						}
					]
				},
				{
					headerName: this.$t("trackPay.contractsTable.dispatchAddress"),
					children: [
						{
							headerName: this.$t("common.country"),
							field: "fromCountry",
							sortable: true,
							minWidth: 100
						}
					]
				},
				{
					headerName: this.$t("trackPay.contractsEditModal.delivery"),
					children: [
						{
							headerName: this.$t("trackPay.contractsEditModal.latitude"),
							field: "latitude",
							valueFormatter:
								asDecimal({
									showZeroAsNotAvailable: true,
									showEmptyAsNotAvailable: true,
									decimals: 10
								}),
							sortable: true,
							minWidth: 130
						},
						{
							headerName: this.$t("trackPay.contractsEditModal.longitude"),
							field: "longitude",
							valueFormatter:
								asDecimal({
									showZeroAsNotAvailable: true,
									showEmptyAsNotAvailable: true,
									decimals: 10
								}),
							sortable: true,
							minWidth: 130
						}
					]
				},
				{
					headerName: this.$t("trackPay.contractsTable.shipment"),
					children: [
						{
							headerName: this.$t("common.amount"),
							field: "amount",
							sortable: true,
							valueFormatter: asMoneyAmount(),
							minWidth: 130
						},
						{
							headerName: this.$t("common.ccy"),
							field: "currency",
							minWidth: 80,
							sortable: true
						},
						{
							headerName: this.$t("trackPay.contractsTable.shipDate"),
							field: "invoiceDate",
							type: "invoiceDate",
							valueFormatter: asLocalizedDate(),
							minWidth: 120
						},
						{
							headerName: this.$t("trackPay.contractsTable.deliveryDate"),
							field: "deliveryDate",
							type: "deliveryDate",
							valueFormatter: asLocalizedDate(),
							minWidth: 140
						}
					]
				},
				{
					headerClass: "bg_special",
					children: [
						{
							headerName: this.$t("common.actions"),
							cellRendererFramework: "TrackAction",
							cellRendererParams: {
								showDetail: this.showDetail,
								showTrackingDetail: this.showTrackingDetail,
							},
							minWidth: 90,
							pinned: "right"
						}
					],
					pinned: "right"
				}
			];
		},
    getList() {
      this.rowData = [];

			let postData = {
				columns: [],
				filters: this.filters || [],
				maxResults: 25000,
				offset: 0,
				sorting: this.sorting
			};

      trackPayApi.seller.getSettledContracts(postData)
          .then((res) => {
            this.rowData = res.data;
          })
          .catch(this.toast);
    },
    applyFilter(filters) {
      this.filters = filters;
      this.getList();
    },
	showDetail(data) {
		data.activeType = "process"
		this.$refs.relationModal.showDetail(data);
	},
	showTrackingDetail(data) {
		this.$refs.TrackProgressModal.showTrackingDetails(data);
	}
  }
};
</script>
